var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vehicles_ship"}},[(_vm.receivedData)?_c('div',[_c('SelectGraphic',{attrs:{"receivedData":_vm.receivedData,"id":"vehicles"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }